// noinspection JSUnusedLocalSymbols
import _ from 'lodash';
import DataService from "./data.service";
import MetricService from "./metric.service";

const EVENT = 'event';

export default {

  updateStatus: function (r) {
    switch (_.lowerCase(r.status)) {
      case 'ok':
      case 'clear':
        r.status = 'Clear';
        break;
      case 'critical':
      case 'error':
        r.status = 'Critical';
        break;
      case 'warn':
        r.status = 'Warn';
        break;
      case 'info':
        r.status = 'Info';
        break;
      default:
        break;
    }
    ;
  },

  updateAlertStatuses: function (results) {
    _.forEach(results, r => {
      this.updateStatus(r);
    });
  
    return results;
  },

  updateAlertDefinition: function (r, metricMetadata) {
    this.updateStatus(r);

    let cdr = false;
    if (r.category === EVENT) {
      r.event = true;      
    } else {
      r.event = false;
      r.metric = MetricService.getUpdatedMetricId(metricMetadata, r.metric);

      let selectedCategoryMetadata = _.find(metricMetadata, function (item) {
        return item.id === r.category;
      });
      let categoryMetricsMetadata = _.get(selectedCategoryMetadata, 'metrics');
      let selectedMetricMetadata = _.find(categoryMetricsMetadata, item => item.id === r.metric);


      if (selectedMetricMetadata) {
        if (selectedMetricMetadata.cdr) {
          cdr = selectedMetricMetadata.cdr;
        }
      } else {
        var modelMetaData = _.get(self.selectedCategoryMetadata, 'models');
        _.forEach(modelMetaData, model => {
          selectedMetricMetadata = _.find(categoryMetricsMetadata, item => item.id === r.metric);
          if (selectedMetricMetadata) {
            if (selectedMetricMetadata.cdr) {
              cdr = selectedMetricMetadata.cdr;
            }
            return false;
          }
        });
      }
    }
    r.cdr = cdr;
    
    
    // migrate old way of showing user ratings
    if (r.description && _.includes(r.description, 'fa-star')) {
      r.description = r.description.replaceAll('<i class="fas fa-star"></i>', '★')
                                   .replaceAll('<i class="fal fa-star"></i>', '☆');
    }
  },

  updateAlertDefinitions: function (alerts, results) {
    return DataService.fetchMetricsMetadata().then(metricMetadata => {
      _.forEach(alerts, r => {
        this.updateAlertDefinition(r, metricMetadata);
      });

      return results;
    });
  }

};
